import { useCallback, useEffect, useState } from "react";
import { http } from "../../lib/api";

export function useAdminList(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const reload = useCallback(() => {
    http.get(path).then((r) => setData(r.data)).catch(setError);
  }, [path]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { data, error, reload };
}

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="text-xs font-bold uppercase tracking-wider text-navy/60">{label}</span>
    <div className="mt-1.5">{children}</div>
    {hint && <span className="text-xs text-navy/50 mt-1 block">{hint}</span>}
  </label>
);

export const inputCls = "w-full h-11 rounded-xl border-2 border-border px-3 outline-none focus:border-turq text-navy bg-white";

export const TextInput = (p) => <input {...p} className={inputCls} />;
export const TextArea = (p) => <textarea {...p} className="w-full rounded-xl border-2 border-border px-3 py-2 outline-none focus:border-turq text-navy" />;

export const Toggle = ({ label, checked, onChange, testid }) => (
  <label className="flex items-center gap-2 text-sm font-semibold text-navy cursor-pointer">
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="w-4 h-4 accent-[#00BCEB]" data-testid={testid} />
    {label}
  </label>
);

export const PrimaryBtn = ({ children, className = "", ...p }) => (
  <button {...p} className={`h-11 px-5 rounded-full bg-sun text-navy font-bold hover:bg-[#ffe34d] transition-colors disabled:opacity-50 ${className}`}>{children}</button>
);

export const AdminHead = ({ title, children, sub }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="text-3xl font-extrabold text-navy" data-testid="admin-page-title">{title}</h1>
      {sub && <p className="text-navy/60 mt-1 text-sm">{sub}</p>}
    </div>
    {children}
  </div>
);

export const csv = (arr) => (arr || []).join(", ");
export const fromCsv = (s) => s.split(",").map((x) => x.trim()).filter(Boolean);
